import { render, staticRenderFns } from "./AdminTours.vue?vue&type=template&id=195e9141&scoped=true"
import script from "./AdminTours.vue?vue&type=script&lang=js"
export * from "./AdminTours.vue?vue&type=script&lang=js"
import style0 from "./AdminTours.vue?vue&type=style&index=0&id=195e9141&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195e9141",
  null
  
)

export default component.exports